var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"medida"},[_c('input-comp',{attrs:{"label":"Medida"},model:{value:(_vm.medida),callback:function ($$v) {_vm.medida=$$v},expression:"medida"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }